import React from 'react'
import './hero.css'
import RegularBtn from '../../../../components/buttons/RegularBtn'
import { COLORS } from '../../../../resources/colors-contants'
import { useNavigate } from 'react-router-dom'
import RegularBtn2 from '../../../../components/buttons/RegularBtn2'

const ProductHero: React.FC = () => {
    const navigate = useNavigate()

    const handleNavigate = (path: string) => {
        navigate(path)
    }
    return (
        <div id="background-image">
            <div className="container " style={{ color: COLORS.white_color }}>
                {/* <div id="content"  className=""> */}
                <div
                    id="retailStyle"
                    style={{
                        fontWeight: '400'
                    }}
                    className=""
                ></div>
                <div>
                    <h1
                        className="mb-0 mb-md-4"
                        id="klakSellaStyle"
                        style={{
                            fontWeight: '600'
                        }}
                    >
                        Klakpad Sella
                    </h1>
                </div>
                <div id="heroDesc">
                    <p style={{ fontWeight: '400' }}>Everything you need, both offline and online, from open to shut.</p>
                </div>

                <div className="d-flex mt-4 mb-4">
                    <div className="me-3">
                        {/* <RegularBtn
                            btnAction={() => {
                                navigate('/signup')
                            }}
                            text="Get Started"
                            width="150px"
                            backgroundColor="white"
                            color={COLORS.primary_background}
                            padding="15px"
                            py="0px"
                            borderRadius="10px"
                            borderCol={COLORS.white_color}
                        /> */}
                        <RegularBtn2
                            btnHeight="48px"
                            width="150px"
                            borderColor={`${COLORS.white_color}`}
                            borderRadius="10px"
                            color={COLORS.primary_background}
                            backgroundColor="white"
                            text="Get Started"
                            btnFontSize="16px"
                            btnFontWeight="500"
                            padding="10px 25px"
                            btnAction={() => {
                                navigate('/signup?plan=2&duration=yearly&page=signup&onTrial=true')
                            }}
                        />
                    </div>
                    <div>
                        <RegularBtn2
                            btnAction={() => {
                                navigate('/contact')
                            }}
                             btnHeight="48px"
                            text="Contact Sales"
                            width="170px"
                            backgroundColor="rgba(255, 255, 255, 0.1)"
                            color="white"
                            padding="10px 25px"
                            borderRadius="10px"
                            blurry="blur(10px)"
                            borderColor={`1px solid ${COLORS.white_color}`}
                        />
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
    )
}

export default ProductHero
